import { render, staticRenderFns } from "./VersionDropDown.vue?vue&type=template&id=33339b91&"
import script from "./VersionDropDown.vue?vue&type=script&lang=js&"
export * from "./VersionDropDown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "VersionDropDown.vue"
export default component.exports